import moment from 'moment'

export default class CalendarSlider {
	constructor(params) {
		if (!params) {
			params = {}
		}
		this.params = params

		if (!this.params.page_size) {
			this.params.page_size = 80
		}
		if (!this.params.start_days) {
			this.params.start_days = 365
		}
		if (!this.params.max_years) {
			this.params.max_years = 5
		}

		this.today     = moment().startOf('day')
		this.now_month = moment().format('MMMM')
		this.now_year  = +moment().format('YYYY')
		this.end_year  = this.params.max_years+this.now_year

		this.days = []
		this.current_page = 0

		this.generateDays(-2, this.params.start_days)
	}

	setParams(params){
		this.params = Object.assign(this.params, params)
	}

	getDayBlockWidth(){
		if (!this.params.day_block_width) {
			return 0
		}
		return this.params.day_block_width
	}	

	// Генерация дней для календаря
	// с ago до to
	// 0 - сегодня
	generateDays(ago, to){
		if (+moment().add(ago,'days').format('YYYY') >= this.end_year) {
			return false
		}
		this.days_generating = true
		for(let i=ago; i < to; i++){
			let day = moment().add(i,'days').startOf('day')
			
			this.days.push({
				key:       i,
				timestamp: +day.format('X'),
				month:     +day.format('M'),
				year:      +day.format('YYYY'),
				active:    false,
				disabled:  (i<0 || i > (to-3) ) ? true:false
			})
		}
		this.days_generating = false
		return true
	}

	// Получение дней для страницы
	getPageOffsets(){
		let p_from = this.current_page-3
		if (p_from < 0) {
			p_from = 0
		}
		p_from *= this.params.page_size 

		let p_to = (3+this.current_page)*this.params.page_size

		let left_offset = 0 
		if (this.getDayBlockWidth()) {
			left_offset = p_from*this.getDayBlockWidth()
		}

		return {
			left:left_offset,
			p_from:p_from,
			p_to:p_to,
		}
	}
	getPageDays(){
		let offset = this.getPageOffsets()

		// 3 страницы
		return this.days.slice(offset.p_from, offset.p_to)
	}


	// Получение индекса дня по таймстэмпу
	getDayByTime(timestamp){
		let day = this.days.filter(function(day) {
			return day.timestamp === timestamp
		})[0]
		
		let day_i = this.days.indexOf(day)

		if ( day_i < 0 ) { day_i = 0 }

		return day_i	
	}

	// установка активности дня
	selectDay(day_i){
		if (!this.days[day_i]) {
			return
		}
		this.cur_day = this.days[day_i]
		this.cur_day.active = true
		
		// Убираем "активность"  предыдущего дня
		if (this.prev_cur_day && this.prev_cur_day.active && 
			this.prev_cur_day!==this.cur_day) {
			this.prev_cur_day.active = false
		}
		this.prev_cur_day = this.cur_day
	}
	selectToday(){
		this.selectDay( 
			this.getDayByTime( 
				this.getTodayTime() 
			) 
		)
	}
	
	getTodayTime(){
		return +moment().startOf('day').format('X')
	}

	// Получение смещения прокрутки для дня с заданным индексом
	getDayOffset(day_i){
		return (-2 + day_i) * this.getDayBlockWidth()
	}
	
	getCurDayIndex(){
		return this.days.indexOf(this.cur_day)
	}

	getCurDayOffset(){
		return this.getDayOffset( this.getCurDayIndex() )
	}


	scroll(offset){
		let update = false

		let day_i = 2+Math.round( offset/this.getDayBlockWidth())

		this.cur_day = this.days[ day_i ]	

		this.month = moment().month(this.cur_day.month-1).format('MMMM')
		if (+this.cur_day.year !== +this.now_year) {
			this.month += ' '+this.cur_day.year
		}

		this.current_page = Math.ceil(
			offset / (this.params.page_size*this.getDayBlockWidth())
		)		

		if (this.current_page !== this.prev_current_page) {
			this.left_offset = this.getPageOffsets().left
			update = true
		}

		this.prev_current_page = this.current_page
		
		let gen_days = true
		
		if (!this.days_generating && day_i > 0.55*this.days.length ) {
			gen_days = this.generateDays(this.days.length, 3*this.params.page_size+this.days.length)
		}

		return {
			update:update,
			end: !gen_days,
		}
	}

}




// WEBPACK FOOTER //
// ./src/components/DaySelector/CalendarSlider.js